var	XMLFile = require('../xml/XMLFile'),
	XMLNode = require('../xml/XMLNode');

/**
 * @param {ReferenceNode} oReferenceNode - ReferenceNode object that is the root of this Relationships XMLFile
 * @constructor
 */
function Relationships(oReferenceNode) {
	XMLFile.call(this, Relationships.metadata);

	if (oReferenceNode instanceof XMLFile) {
		this.setFileName(oReferenceNode.getFileName() + '.rels');
		this.setPath(oReferenceNode.getPath() + '_rels/');
	}
}

Relationships.prototype = Object.create(XMLFile.prototype);
Relationships.prototype.constructor = Relationships;

Relationships.metadata = {
	filename: '.rels',
	path: '_rels/',
	tag: 'Relationships',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/package/2006/relationships'
		}
	],
	properties: []
};

/**
 * Creates a new Relationship entry for the current collection.
 * The Relationship references are defined by the ISO/IEC 29500-1:2016 standard.
 *
 * @param {string} sTarget - Target file within the generated Excel
 * @param {string} sType - XMLNS reference of the targets file type
 * @returns {string} The newly created relationship id that can be referenced i.E. "rId4"
 */
Relationships.prototype.addRelationship = function(sTarget, sType) {
	var id = 'rId' + (this.childs.length + 1);

	this.childs.push(new XMLNode({
		tag: 'Relationship',
		attributes: [
			{
				name: 'Id',
				value: id
			},
			{
				name: 'Type',
				value: sType
			},
			{
				name: 'Target',
				value: sTarget
			}
		]
	}));

	return id;
};

module.exports = Relationships;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/objects/Relationships.js
// module id = 8
// module chunks = 0